export const bannerInfosData = [
  {
    BannerTitle: "Products May Interest You",
    BannerSubTitle: "Discover the latest trends",
    BannerDiscription:
      "Let this be your go-to spot for all things related to denim and knit trends including new fabrics, fits, sustainable wash and dying methods.",
    BannerButtonText: "Go to for you",
    shadowBlock: false,
    buttonDistance: "80px",
  },
  {
    BannerTitle: "Direct Order",
    BannerSubTitle: "Everything happens here!",
    BannerSubTitleFollow: "Place your order in one click",
    BannerDiscription:
      "Create your own collections here adding your collaborators to help you think about all the elements needed for launching your samples by first naming your collections, the products and options you may have. Then enter the name of the style and fabric you would want to us. After, give us some wash instruction, an image or mood board. Details about thread and trims if you’d like to. That’s it order placed! Quicker than an email",
    BannerButtonText: "Send your order",
    shadowBlock: false,
    buttonDistance: "80px",
  },
  {
    BannerTitle: "Our Philosophy",
    BannerSubTitle: "We stand for",
    BannerSubTitleFollow: "innovative thinking !",
    BannerDiscription: `High expectations on design, quality and material as well as the latest processing technologies. Our goal is to continually find sustainable ways to improve our performance to assure an outstanding service in order to continuously exceed our customers’ expectations.`,
    BannerButtonText: "Go to creative station",
    shadowBlock: false,
    buttonDistance: "80px",
  },
];

export const bannerInfosCustomization = {
  BannerTitle: "Product Customization",
  BannerSubTitle: "Customize all of our products",
  BannerSubTitleFollow: "to better represent the brand’s identity",
  BannerDiscription: `You can change the fit, fabrics, base colours, laser intensity and damages to design your own custom product via our interactive platform.
  The design process is very easy & quick, allowing you to get details that we may have missed or some changes you may want to apply.`,
  BannerButtonText: "Go to  products",
  shadowBlock: true,
  buttonDistance: "80px",
};

export const bannerInfosDifference = {
  BannerTitle: "What Makes Us Different",
  BannerSubTitle: "Created by a creative team ",
  BannerSubTitleFollow: "to meet ambitious expectations",
  BannerDiscription: `The Creative Team works very hard each season to present you the best quality / price / interesting products following a study of the trends, fairs and other flow of inspiration. In this section we will share with you our vision, trend boards and other innovative ideas.`,
  shadowBlock: true,
  buttonDistance: "80px",
};
